<template>
<div class="main-in">
    <div is='titlebox' :nav='JSON.parse(nav)' :isSearch='type>2?true:false' @onSearch='onSearch'></div>
    <div class="container" v-cloak>
        <div class="content">
            <!-- <div class="left-corner f-row-l"> 
                <div class=" f-row-l" style="height:47px">
                    <div class="bg-title1 f-row-c bbact">{{title}}</div>
                </div>
                <div class="f-row-l inpbox" v-if='type>2'>
                    <el-input v-model="search" class="inp" prefix-icon="el-icon-search" size="small"></el-input>
                    <el-button type="text" class="btn" @click="onSearch()">搜索</el-button>
                </div>
            </div> -->
            <div class="min-h f-row-l align-start">
                <div class="mt22">
                   <div class="defbtn bb-1" :class="item.slotTitle==type?'brief':''" v-for='(item,ind) in brief2' :key="ind" @click="btn(item)">{{item.label}}</div>
                </div>
                <div :class="brief2.length>0?'words-r':'w-100'">
                    <div is='tel' v-if='type==1'></div>
                    <div is='rightsSevOnline' v-if='type==2'></div>
                    <div v-if='type>2' class="">
                        <div class="w-100 min-h">
                            <ul v-if='list.length>0'>
                                <li class="pinter overf-elli act-h" v-for="(item, i) in list" :key="i" :title="(item.title)" @click="Xx(item)">
                                    <div class="triangle"></div>
                                    {{ item.title }}
                                    <span>{{ item.createTime }}</span>
                                </li>
                            </ul>
                            <div v-else class="f-row-c mt-2 mb-2 color-gray h-200">暂无数据</div>
                        </div>
                        <div class="block" v-show='list.length>0'>
                            <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="param.pageNo"
                            :page-size="param.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="param.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    
</template>
<script>
import tel from './tel.vue';//热线电话1
import rightsSevOnline from './rightsSevOnline.vue';//在线维权2

export default {
    components:{
        tel,rightsSevOnline
    },
    computed:{
        nav:function(){ 
            var arr=[
                {
                    label:this.title,
                    path:'/Rights?type='+this.$route.query.type,
                    type:this.$route.query.type
                }
            ]
            return JSON.stringify(arr)
        }
    },
    data(){
        return{
            type:this.$route.query.type,
            title:'维权服务',
            // search:'',
            brief2:[
                {label: '热线电话',title: '/Rights?type=1',slotTitle:1},
                // {label: '在线维权',title: '/Rights?type=2',slotTitle:2},
                {label: '维权案例',title: '/Rights?type=3',slotTitle:3},
                {label: '法律政策',title: '/Rights?type=4',slotTitle:4},
                {label: '法律维权',title: '/Rights?type=5',slotTitle:5},
            ],
            list:[],
            param:{
                pageNo:1,//分页 
                pageSize:10,
                total: 0,
            }
        }
    },
    mounted(){
        this.type=this.$route.query.type?this.$route.query.type:1;
        this.typeIs();
    },
    watch:{
        $route(to,from,next){
            if(to.path.indexOf('/Rights')!=-1){
                this.type=this.$route.query.type;
                this.param.pageNo=1
                this.typeIs();
            }
        },
    },
    methods:{ 
         btn(item){
            //  this.$util.goTop()
            this.type=item.slotTitle
            // this.list=[]
            // this.typeIs();
            this.$router.push({path:'/Rights',query:{type:item.slotTitle}});
        },
        Xx(item){
            this.$util.goTop()
            this.$router.push(`/newDetail?type=24&id=${item.id}&isPrivate=${this.type}`);
        },
        onSearch(e){
            this.param.title="*"+e+"*"
            this.typeIs();
        },
         handleSizeChange(val) {
            this.$util.goTop()
            console.log(`每页 ${val} 条`);
            this.param.pageSize=val;
            this.typeIs();
        },
        handleCurrentChange(val) {
            this.$util.goTop()
            console.log(`当前页: ${val}`);
            this.param.pageNo=val;
            this.typeIs();
        },
        getList(){
            this.list=[];
            this.$get('/web/doorProtect/list',this.param).then(res=>{ 
                if(res.success){ 
                    this.list=res.result.records
                    this.param.total= res.result.total
                }
            })
        },
        
        typeIs(){
            switch(this.type*1){ 
                case 1: 
                    this.title='热线电话';
                break;
                case 2: 
                    this.title='在线维权';
                break;
                case 3: 
                    this.param.protectType=0
                    this.title='维权案列';
                    this.getList()
                break;
                case 4: 
                    this.param.protectType=1
                    this.title='法律政策';
                    this.getList()
                break;
                case 5: 
                    this.param.protectType=2
                    this.title='法律维权';
                    this.getList()
                break;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.content{
    padding: 0px 50px;
}
.brief,.defbtn{
    margin-top: 0px;
}
.bb-1{
    border-bottom: 1px solid #ffffff;
}
.left-corner {
    border-bottom: 1px solid #D6DDE6;
}

ul {
    width: 100%; 

    li{
        width: 100%;
        list-style: none;
        text-align: left;
        display: inline-block;
        line-height: 25px;
        padding-bottom:15px;
        padding-top: 15px;
        border-bottom: 1px dashed #E0E0E0 ;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        padding-right: 180px;
        position: relative;
            span{
                font-size: 14px;
                color: #999999;
                position: absolute;
                right: 20px;
                font-weight: 100;
            }
    }
}
.h-200{
    height: 200px;
}
.block{
    position: relative;
    text-align: center;
    line-height: 50px;
    margin-top: 20px;
}
</style>